﻿'use strict';

angular.module('ntmApp').controller('AppOptionsBtnController', ['$scope', 'data', '$uibModalInstance', 'EditForm', 'FormService', 'ListGridConstants', function ($scope, data, $uibModalInstance, EditForm, FormService, ListGridConstants) {

    $scope.dismiss = function () {
        $uibModalInstance.dismiss();
    };

    function initialize() {
        $scope.loading = true;

        if (!data.button || !data.button.htmlPageId) {
            return;
        }
		
		var requestData = {
			id: data.button.htmlPageId
		};

        FormService.GetForm(requestData).then(function (result) {

            result.data.onDataUpdatedMethod = function () {
                $uibModalInstance.dismiss();
                data.onDataUpdatedMethod();
            };
			
			result.data.action = ListGridConstants.Operation.INSERT;
            result.data.pageType = ListGridConstants.SectionType.GeneralPage;
			result.data.doNotReset = true;

            var form = data.setDefaults(result.data, data.button);
            $scope.editForm = new EditForm(form);
            $scope.loading = false;
        });
    }


    initialize();

}]);